<script setup lang="ts">
import UiFieldWrapper from "./UiFieldWrapper.vue"

const model = defineModel<string>({ default: "" })

withDefaults(
  defineProps<{
    id: string
    label: string
    type?: "text" | "email" | "number" | "date"
    placeholder?: string
    required?: boolean
    disabled?: boolean
    error?: string
    helperText?: string
    step?: string | number
  }>(),
  {
    type: "text",
    placeholder: "",
    required: false,
    disabled: false,
    error: "",
    helperText: "",
    step: undefined,
  }
)
</script>

<template>
  <UiFieldWrapper :label="label" :for-id="id" :error="error" :helper-text="helperText">
    <input
      :id="id"
      v-model="model"
      :type="type"
      :placeholder="placeholder"
      :required="required"
      :disabled="disabled"
      :step="step"
      class="w-full rounded-md border border-slate-300 px-3 py-2 text-sm text-slate-900 transition placeholder:text-slate-400 focus:border-slate-400 focus:outline-none"
    />
  </UiFieldWrapper>
</template>

